<template>
  <div
    ref="container"
    class="p-splitter-panel"
    :class="{ 'p-splitter-panel-nested': this.isNested }"
    data-pc-name="splitterpanel"
  >
    <slot></slot>
  </div>
</template>

<script>
import BaseSplitterPanel from "./BaseSplitterPanel.vue";

export default {
  name: "SplitterPanel",
  mixins: [BaseSplitterPanel]
};
</script>

<style>
.p-splitter-panel {
  flex-grow: 1;
}

.p-splitter-panel-nested {
  display: flex;
}

.p-splitter-panel .p-splitter {
  flex-grow: 1;
  border: 0 none;
}
</style>
